import { render, staticRenderFns } from "./PzUnnax.vue?vue&type=template&id=23953b50&scoped=true&"
import script from "./PzUnnax.vue?vue&type=script&lang=js&"
export * from "./PzUnnax.vue?vue&type=script&lang=js&"
import style0 from "./PzUnnax.vue?vue&type=style&index=0&id=23953b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23953b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23953b50')) {
      api.createRecord('23953b50', component.options)
    } else {
      api.reload('23953b50', component.options)
    }
    module.hot.accept("./PzUnnax.vue?vue&type=template&id=23953b50&scoped=true&", function () {
      api.rerender('23953b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/PayIn/PzUnnax.vue"
export default component.exports